import React, { useContext, useLayoutEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { AppSettings } from '../config/app-settings';
import './public.css';

export default function PublicPage({ children }) {
  const { setAppHeaderNone } = useContext(AppSettings);
  const { i18n } = useTranslation();
  useLayoutEffect(() => {
    setAppHeaderNone(true);
    document.body.classList.add('public-page-active');
    return () => {
      setAppHeaderNone(false);
      document.body.classList.remove('public-page-active');
    };
  }, [setAppHeaderNone]);
  useLayoutEffect(() => {
    document.documentElement.lang = i18n.resolvedLanguage?.startsWith('en') ? 'en' : 'sv';
  }, [i18n.resolvedLanguage]);
  return <div className="klargo-public">{children}</div>;
}
